import { render, staticRenderFns } from "./RentalComponent.vue?vue&type=template&id=ea28e65a&"
import script from "./RentalComponent.vue?vue&type=script&lang=js&"
export * from "./RentalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports